<template>
  <div
    :style="{
      'background-color': useBackgroundColor,
      'padding-top': paddingTop ? paddingTop + 'px' : '',
      'padding-bottom': paddingBottom ? paddingBottom + 'px' : ''
    }"
    :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
    class="column col-6"
    @click="$emit('block:redirect')"
  >
    <a
      v-if="mainFields?.value?.value?.startsWith(['https://'])"
      :href="mainFields?.value?.value"
      target="_blank"
      class="box-link"
    >
      <div class="box-link__image">
        <ui-image
          :file-data="{ fileId: mainFields?.image?.value }"
          :loading="'lazy'"
        />
      </div>
      <div class="box-link__title">
        {{ mainFields?.text?.value }}
      </div>
    </a>
    <nuxt-link
      v-else
      :to="{ path: mainFields?.value?.value?.[0] === '/' ? mainFields?.value?.value : `/${mainFields?.value?.value}` }"
      class="box-link"
    >
      <div class="box-link__image">
        <ui-image
          :file-data="{ fileId: mainFields?.image?.value }"
          :loading="'lazy'"
        />
      </div>
      <div class="box-link__title">
        {{ mainFields?.text?.value }}
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  name: 'PageMimiTextBlock',
  mixins: [staticBlockMixin]
}
</script>

<style scoped>
.box-link__title {
    margin-right: 80px;
}
</style>
